module.exports = __webpack_public_path__ + "53f60bffdaa4afc444f13572f585a51a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/sync/screen/mobile.png
// module id = 1828
// module chunks = 1